<template>
  <div class="row standards_main m-0">
    <div class="col-md-12 p-0" >
      <div class="content-body">
          <div class="pb-24">
          <p class="m-0 standards_title">{{ $t('standards') }}</p>
           </div>
         <div class="row m-0 search_main">
          <div class="col-xs-12 col-sm-12 col-md-12 pl-24 pr-0 m-0" style="padding-top: 16px;">
            <p class="text_body m-0 pb-24">
            {{$t('searchInmetroStandards')}}
          </p>
           <div class="row mr-bt-20" v-if="this.permissions.indexOf('REG_TRACKER_RECORDS') !== -1">
              <div class="col-md-1 col-sm-2 col-xs-2 text_align_right mt-40 ">
                 <el-radio
                  v-model="type"
                  @change="radioEventProductCategory"
                  class="tools_radio"
                  label="product_category"

                >&nbsp;</el-radio>
                <!-- <div class="pb-25">
                 <label>
                <input type="radio"  v-model="type"
                 @change="radioEventSpeciality"
                  label="product_name" />
                <span></span>
              </label>
            </div> -->
              </div>
              <div class="col-md-5 col-sm-10 col-xs-10 pl-4">
                 <div class="label_name pb-9">{{$t('productCategory')}}</div>
              <multiselect
                openDirection="below"
                :disabled="disableProductCategory"
                 :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                class="product-class-ellipsis multiselect-single-dropdown"
                @search-change="searchMethodProductNames"
                :searchable="true"
                :options="productCategories.map(product => product.product_category_id)"
                :custom-label="(opt) => productCategories.find((x) => x.product_category_id === opt).product_category_name || ''"
                v-model="state0"
                :placeholder="$t('selectItem')"
              >
               <span slot="noOptions">{{ $t('listEmpty') }}</span>
              <span slot="noResult">{{ $t('noMatchingData') }}</span>
              </multiselect>
              </div>
            </div>
            <div class="row mr-bt-20" v-if="this.permissions.indexOf('REG_TRACKER_RECORDS') !== -1">
              <div class="col-md-1 col-sm-2 col-xs-2 text_align_right mr-tp-7"></div>
              <div class="col-md-5 col-sm-10 col-xs-10 pl-4 or" >{{$t('OR')}}</div>
            </div>
            <div class="row mr-bt-20" v-if="this.permissions.indexOf('REG_TRACKER_RECORDS') !== -1">
              <div class="col-md-1 col-sm-2 col-xs-2 text_align_right mt-40 ">
                 <el-radio
                  v-model="type"
                  @change="radioEventSpeciality"
                  class="tools_radio"
                  label="product_name"

                >&nbsp;</el-radio>
                <!-- <div class="pb-25">
                 <label>
                <input type="radio"  v-model="type"
                 @change="radioEventSpeciality"
                  label="product_name" />
                <span></span>
              </label>
            </div> -->
              </div>
              <div class="col-md-5 col-sm-10 col-xs-10 pl-4">
                 <div class="label_name pb-9" >{{$t('Product')}}</div>
              <multiselect
                openDirection="below"
                :disabled="disableProductName"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                class="product-class-ellipsis multiselect-single-dropdown"
                @search-change="searchMethodProductNames"
                :searchable="true"
                :options="productFullNames.map(product => product.product_id)"
                :custom-label="(opt) => productFullNames.find((x) => x.product_id === opt).product_name || ''"
                v-model="state1"
                :placeholder="$t('selectItem')"
              >
               <span slot="noOptions">{{ $t('listEmpty') }}</span>
              <span slot="noResult">{{ $t('noMatchingData') }}</span>
              </multiselect>
              </div>
            </div>
            <div class="row mr-bt-20" v-if="this.permissions.indexOf('REG_TRACKER_RECORDS') !== -1">
              <div class="col-md-1 col-sm-2 col-xs-2 text_align_right mr-tp-7"></div>
              <div class="col-md-5 col-sm-10 col-xs-10 or pl-4" >{{$t('OR')}}</div>
            </div>
            <div class="row mr-bt-20" v-if="this.permissions.indexOf('REG_TRACKER_RECORDS') !== -1">
              <div class="col-md-1 col-sm-2 col-xs-2 text_align_right mt-40">
                <el-radio
                  v-model="type"
                  @change="radioEventProduct"
                  class="tools_radio"
                  label="product_code"

                >&nbsp;</el-radio>
              </div>
              <div class="col-md-5 col-sm-10 col-xs-10  pl-4">
                 <div class="label_name pb-9 " >{{$t('productClass')}}</div>
              <multiselect
                openDirection="below"
                :disabled="disableProductCode"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                class="product-class-ellipsis multiselect-single-dropdown"
                :searchable="true"
                @search-change="searchMethodProductCodes"
                :options="productClasses.map(product => product.product_class_id)"
                :custom-label="(opt) => productClasses.find((x) => x.product_class_id === opt).product_class_name || ''"
                v-model="state2"
                :placeholder="$t('selectItem')"
              >
               <span slot="noOptions">{{ $t('listEmpty') }}</span>
              <span slot="noResult">{{ $t('noMatchingData') }}</span>
              </multiselect>
              </div>
            </div>
            <div class="row ">
              <div class="col-md-1 col-sm-2 col-xs-2"></div>
              <div class="col-md-5 col-sm-10 col-xs-10 center"> <span class="csfcn_error">{{err}}</span></div>

            </div>
            <div class="row">
              <div class="col-md-6 col-xs-12 col-sm-12">
                <!-- <el-tooltip
                popper-class="w-150"
                effect="dark"
                :content="$t('searchBarToolTipInStandards')"
                placement="top"
                > -->
                  <button
                    :disabled="!type"
                    class="btn search-blue-button"
                    :class="this.$i18n.locale==='Portuguese'?'w-108':!type?'not-allowed':''"
                    @click="searchHere"
                  >{{$t('search')}}</button>
                <!-- </el-tooltip> -->
              </div>
            </div>
            <div class="hr-line"></div>
            <div class="row" >
                <div class="col-md-12 col-xs-12 col-sm-12">
                    <div> <p class="m-0 text_body pb-16">{{ $t('standardApplicationLabel') }}</p></div>
                    <div class="col-xs-12 p-0 " v-if="isSearch&& isResult &&(state0||state1||state2)">
                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0 search-container-wraper search-outer">
                              <div class="search-container reg-search col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 pr-24">
                                <div style="position:relative">
                                  <search-box  v-model="searchValue" :searchCount="searchCount" @getList="filterRegulationsList"></search-box>
                                </div>
                              </div>
                          </div>
                    </div>
                     <div class="col-xs-12 col-sm-12 col-md-12 pl-0 pr-24 regulationBackground" >
         <div id="regulation_table" >
        <table class="table table-responsive registration-data" id="regulationDataList" >

            <tr style="background-color: #E6E6E6; !important;" v-if="isSearch&&isResult">

              <th>
                <div class="tableHeader cursor-pointer" @click="arrowDirection.regulationName = -(arrowDirection.regulationName), sortBy('standards', arrowDirection.regulationName)">
                  <div class="header-ellipsis header-title" :title="$t('standards')">{{$t('standards')}}</div>
                  <div class="arrow" :class="arrowDirection.regulationName === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>

            </tr>

          <tbody ref="tbodyBox" v-if="standards.length&&isSearch&&isResult" >
            <tr
            :class="index%2===0?'table_data_part1':'table_data_part2'"
            v-for="(data, index) in standards" :key="index">

              <td  class="ellipsis regulation-data"><span :title="data.standard">{{ data.standard }}</span></td>

             </tr>
          </tbody>
        </table>
         <div v-if="!standards.length&&isSearch" class="no-records">
              <p class="no-records-found">{{$t('standardsEmptyStateMessage')}}</p>
        </div>
        <div v-else-if="!isResult&&!isSearch" class="no-records">
              <!-- <p class="no-records-found">{{$t('standardSearchEmptyText')}}</p> -->
              <div class="m-0 no-records-found">{{$t('standardSearchEmptyTextPart1')}} <br/> <span class="w-105"> {{$t('standardSearchEmptyTextPart2')}}</span></div>
              <!-- <div class="m-0"> above to view standards.</div> -->
        </div>
         </div>
          </div>
                  </div>
              </div>
            </div>

        </div>
        <div class="footer"></div>

      </div>

    </div>
     <loader :loadingStatus="loaderStatus"></loader>

  </div>
</template>
<script>
import Loader from '../UIComponents/Loader.vue';
import 'element-ui/lib/theme-chalk/index.css';
import { getData, callSearch, searchProductCategories } from '../../apis/classification';
import EventBus from '../../utils/event-bus';
import permissionsList from '../UIComponents/mixins/rbacPermissionsMixin';
import SearchBox from '../UIComponents/ULSearchBox.vue';
import sortMixin from '../UIComponents/mixins/sortByMixin';

export default {
  mixins: [permissionsList, sortMixin],
  data() {
    return {
      searchValue: '',
      searchCount: 0,
      search_type: '',
      specialityDropdown: false,
      medicalDropdown: true,
      productsUrl: '/resources/products',
      productClassesUrl: '/resources/productClasses',
      searchUrl: '/class',
      radio: 1,
      btnTxt: 'Search',
      err: '',
      disabled: false,
      loaderStatus: false,
      productNames: [],
      productCodes: [],
      fullProductNames: [],
      productFullNames: [],
      fullProductCodes: [],
      productClasses: [],
      productCategories: [],
      state0: '',
      state1: '',
      state2: '',
      isResult: false,
      type: '',
      loading: false,
      result: '',
      searchProductKey: '',
      searchProductName: '',
      disableProductCode: true,
      disableProductName: true,
      disableProductCategory: true,
      standards: [],
      standardsApplicable: '',
      noStandardsApplicable: '',
      permissions: [],
      arrowDirection: {
        regulationName: 1,
      },
      isPreviouslySearched: false,
      filteredRegulationData: [],
      isSearch: false,
    };
  },
  components: {
    Loader,
    SearchBox,
  },
  async mounted() {
    await this.validateFeatures();
    this.loadData();
    // this.radioEventProductCategory();
    EventBus.$on('updateLanguage', (language, oldLanguage) => {
      if (language !== oldLanguage) {
        this.$router.go();
      }
    });
  },
  methods: {
    async loadData() {
      this.loaderStatus = true;
      const url = `/resources/products?accountId=${JSON.parse(localStorage.getItem('accountId'))}`;
      this.productFullNames = await getData(url);

      // this.productFullNames = await getData(this.productsUrl);
      // if (
      //   productNamesData.status_code === 200
      //   && productNamesData.message === 'success'
      // ) {
      //   this.fullProductNames = productNamesData.data;
      // }
      this.productClasses = await getData(this.productClassesUrl);
      const productCategoryUrl = '/resources/product_category';
      this.productCategories = await getData(productCategoryUrl);

      // if (
      //   productCodesData.status_code === 200
      //   && productCodesData.message === 'success'
      // ) {
      //   this.fullProductCodes = productCodesData.data;
      // }
      this.loaderStatus = false;
    },
    radioEventSpeciality() {
      this.disableProductCode = true;
      this.disableProductName = false;
      this.disableProductCategory = true;
      this.isResult = false;
      this.type = 'product_name';
      this.productNames = [];
      this.productNames = this.fullProductNames.slice(0, 9);
      this.specialityDropdown = false;
      this.medicalDropdown = true;
      this.state2 = '';
      this.state0 = '';
      this.isSearch = false;
    },
    radioEventProduct() {
      this.disableProductCode = false;
      this.disableProductName = true;
      this.disableProductCategory = true;
      this.isResult = false;
      this.type = 'product_code';
      this.productCodes = [];
      this.productCodes = this.fullProductCodes.slice(0, 9);
      this.specialityDropdown = true;
      this.medicalDropdown = false;
      // eslint-disable-next-line no-multi-assign
      this.state0 = this.state1 = '';
      this.isSearch = false;
    },
    radioEventProductCategory() {
      this.disableProductCategory = false;
      this.disableProductCode = true;
      this.disableProductName = true;
      this.isResult = false;
      this.type = 'product_category';
      this.productNames = [];
      this.productNames = this.fullProductNames.slice(0, 9);
      // this.specialityDropdown = false;
      // this.medicalDropdown = true;
      // eslint-disable-next-line no-multi-assign
      this.state1 = this.state2 = '';
      this.isSearch = false;
    },

    specialityHandleSelect(item) {
      this.state1 = item;
    },
    productHandleSelect(item) {
      this.state2 = item;
    },
    searchMethodProductNames(query) {
      const temp = [];
      if (!query && !this.state1) this.searchProductName = '';
      if (query) { this.searchProductName = query; this.state1 = ''; }
      const minLengthSearchKeyWords = this.isAllWordsHavingLength(this.searchProductName);
      if (minLengthSearchKeyWords.length === 0) {
        this.productNames = this.fullProductNames.slice(0, 9);
      } else if (this.searchProductName.length >= 3) {
        this.productNames = [];
        this.loaderStatus = true;
        for (let j = 0; j < this.fullProductNames.length; j += 1) {
          const result = this.multiSearchOr(
            this.fullProductNames[j].toLowerCase(),
            minLengthSearchKeyWords,
          );
          if (result > 0) {
            temp.push(this.fullProductNames[j]);
          }
        }
        this.productNames = temp;
        this.loaderStatus = false;
      }
    },
    isAllWordsHavingLength(searchWords) {
      const strArray = searchWords.split(' ');
      const searchItems = [];
      for (let i = 0; i < strArray.length; i += 1) {
        const searchItem = strArray[i].trim();
        if (searchItem.length >= 3) {
          searchItems.push(searchItem.toLowerCase());
        }
      }
      return searchItems;
    },
    multiSearchOr(text, searchWords) {
      for (let i = 0; i < searchWords.length; i += 1) {
        const searchItem = searchWords[i]
          .replace(/([()[{*+.$^\\|?])/g, '\\$1')
          .trim();
        if (searchItem.length >= 3) {
          if (text.search(searchItem) === -1) return 0;
        }
      }
      return 1;
    },
    searchMethodProductCodes(query) {
      this.loading = true;
      if (!query && !this.state2) this.searchProductKey = '';
      if (query) { this.searchProductKey = query; this.state2 = ''; }
      if (this.searchProductKey.trim()) {
        this.productCodes = this.fullProductCodes.filter((item) => {
          const val = item.toLowerCase().slice(0, this.searchProductKey.length);
          return val.indexOf(this.searchProductKey.toLowerCase()) > -1;
        });
      } else {
        this.productCodes = this.fullProductCodes.slice(0, 9);
      }
      this.loading = false;
    },
    focusProductName() {
      this.isResult = false;
      // const value = this.state1;
      // if (value.trim().length === 0) {
      //   this.productNames = this.productFullNames.slice(0, 9);
      // }
    },

    selectProductName() {
      const value = this.state1;
      if (value) {
        const index = this.fullProductNames.indexOf(value);
        if (index === -1) {
          this.state1 = '';
        }
      }
    },
    /* selectProductCode()
     * to trigger event when product code is selected.
     */
    selectProductCode() {
      this.isResult = false;
      const value = this.state2;
      if (value) {
        const index = this.fullProductCodes.indexOf(value.toUpperCase());
        if (index === -1) {
          this.state2 = '';
        }
      }
    },
    /* focusProductCode()
     * to trigger event when product code search dropdown is focused.
     */
    focusProductCode() {
      this.isResult = false;
      // const value = this.state2;
      // if (value.trim().length === 0) {
      //   this.productCodes = this.fullProductCodes.slice(0, 9);
      // }
    },
    languageSelected() {
      if (this.$i18n.locale === 'English') {
        this.standardsApplicable = 'Standards applicable for above selected Regulation';
        this.noStandardsApplicable = 'No standards applicable';
      } else {
        this.standardsApplicable = 'Normas aplicáveis ​​ao Regulamento selecionado acima';
        this.noStandardsApplicable = 'Nenhum padrão aplicável';
      }
    },
    searchHere() {
      EventBus.$on('standardsApplicableEmitted', this.languageSelected);
      this.languageSelected();
      this.isResult = false;
      let selectedValue = '';
      if (!this.type) {
        this.err = 'Please Select Search Type ';
        return;
      }
      if (!this.state1 && this.type === 'product_name') {
        if (this.$i18n.locale === 'Portuguese') {
          this.err = 'Selecione o produto';
          return;
        }
        this.err = 'Please Select Product';
        return;
      }
      if (this.state1 && this.type === 'product_name') {
        selectedValue = this.productFullNames.find((obj) => obj.product_id === this.state1).product_class_id;
      } else if (!this.state2 && this.type === 'product_code') {
        if (this.$i18n.locale === 'Portuguese') {
          this.err = 'Por favor, selecione a classe do produto';
          return;
        }
        this.err = 'Please Select Product Class';
        return;
      } else if (this.state2 && this.type === 'product_code') {
        selectedValue = this.state2;
      } else if (!this.state0 && this.type === 'product_category') {
        if (this.$i18n.locale === 'Portuguese') {
          this.err = 'Selecione a categoria do produto';
          return;
        }
        this.err = 'Please Select Product Category';
        return;
      } else if (this.state0 && this.type === 'product_category') {
        selectedValue = this.state0;
      }
      this.isSearch = true;
      this.err = '';
      this.btnTxt = 'Please Wait....';
      this.isResult = false;
      this.disableProductCode = true;
      this.disableProductName = true;
      this.disableProductCategory = true;
      this.loaderStatus = true;
      setTimeout(async () => {
        const response = this.state0 && this.type === 'product_category' ? await searchProductCategories(selectedValue) : await callSearch(selectedValue);
        this.standards = response;
        this.filteredRegulationData = response;
        this.searchCount = this.standards.length;
        this.isResult = true;
        if (this.type === 'product_name') {
          this.disableProductName = false;
        }
        if (this.type === 'product_code') {
          this.disableProductCode = false;
        }
        if (this.type === 'product_category') {
          this.disableProductCategory = false;
        }
        this.loaderStatus = false;
        this.btnTxt = 'Search';
      }, 2000);
    },
    resetAll() {
      this.isResult = false;
      this.result = '';
      this.state1 = '';
      this.state2 = '';
    },
    async validateFeatures() {
      this.permissions = [];
      const servicesList = ['REG_TRACKER'];
      const modulesList = ['REG_TRACKER_RECORDS', 'REG_TRACKER_REPORTS'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
    },
    filterRegulationsList() {
      if (this.searchValue) {
        this.filterRegulations();
        this.isPreviouslySearched = true;
      } else if (this.isPreviouslySearched) {
        this.filterRegulations();
        this.isPreviouslySearched = false;
      }
    },
    async filterRegulations() {
      const searchStr = this.searchValue.trim();

      this.standards = [];
      if (!searchStr.length) {
        this.standards = this.filteredRegulationData;
        this.searchCount = this.standards.length;
        return;
      }
      this.standards = this.filteredRegulationData.filter((each) => this.searchString(searchStr, each));
      this.searchCount = this.standards.length;
    },
    searchString(searchValue, regulationsData) {
      if ((regulationsData.standard.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }

      return false;
    },
  },
};
</script>
<style scoped>
.multiselect-single-dropdown >>> .multiselect__option:hover {
  border:1px solid #0A99ff !important;
}
.pl-4 {
  padding-left:4px;
}
.w-108 {
  width:120px !important;
}
.w-105 {
  width:105px !important;
}

#regulation_table::-webkit-scrollbar {
  width: 6px;
}
#regulation_table::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
#regulation_table {
  margin-bottom: 10px;
  max-height: calc(80vh - 142px);
  overflow-y: auto;
  overflow-x: hidden;
}
.footer {
  min-height: 25px;
}
.no-records {
  min-height:250px;
  display: flex;
  align-items: center;
  justify-content:center;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;

}
.not-allowed {
  cursor: not-allowed !important;
}
.items-opacity {
  opacity:0.4
}
.mt-40 {
  padding-top:40px
}
.table_data_part1{
  background-color: #FAFAFA;
}
.table_data_part2{
  background-color: #F5F5F5;
}
.regulation-data {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  padding: 14px 0px 16px 12px !important;
}
#regulationDataList th .arrow {
  opacity: 1;
}
.tableHeader {
  display: flex;
  align-items: center;
  padding:14px 0px 12px 12px;
  column-gap: 7px
  /* justify-content: center; */
}
.down-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #999999;
}

.up-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #999999;
}
.search-blue-button,
.search-blue-button:hover {
  background-color: #01518A;
  height: 44px;
  width: 91px;
  color: #FFFFFF !important;
  font-size: 18px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 25px;
  float: right;
  cursor: pointer;
  padding: 6px 16px;
}
.pb-9 {
  padding-bottom: 9px;
}
.pb-16 {
  padding-bottom: 16px;
}
.label_name {
  font-weight: 400;
font-size: 16px;
line-height: 22px;
color: #3e3e3e;
}
/* label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 0px !important;

}
/* label>input[type="radio"] {
    display: none;
}
label>input[type="radio"]+*::before {
    content: "";
    display: inline-block;
    vertical-align: bottom;
    width: 18px;
    height: 18px;
    margin-right: 11px;
    margin-bottom: 4px;
    border-radius: 50%;
    border-style: solid;
    border-width: 1px;
    border-color: #00518a;
    border: 2px solid #4d4d4d;
}

label>input[type="radio"]:checked+*::before {
    background: radial-gradient(#00518a 0%, #00518a 46%, transparent 51%, transparent);
    border-color: #00518a;
    border: 2px solid #00518a;
} */
.hr-line {
   border-bottom:0.6px solid #D3D3D3;
   margin:24px 23px 16px 0px;

}

.search_main {
  background: #FFFFFF;
  border: 1px solid #B3B3B3;
}
.standards_main {
  padding-left:26px;
  padding-right: 24px;
  background-color:#ebebeb;
  height: 100vh !important;
}
.standards_title {
font-weight: 400;
font-size: 24px;
line-height: 34px;
color: #3E3E3E;
}
.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
  padding-top: 0px !important;
}
.product-class-ellipsis.multiselect-single-dropdown
>>> .multiselect__single,
.accredited-by-ellipsis.multiselect-single-dropdown
>>> .multiselect__single{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 450px;
  margin-bottom: 0px;
}
.multiselect-single-dropdown.multiselect--active::before{
  content: none;
}
.multiselect--active
  >>> .multiselect__tags{
    border-radius: 3px !important;
    border-bottom: none;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-top: 1px solid #CCCCCC;
    border-right: 1px solid #CCCCCC;
    border-left: 1px solid #CCCCCC;
  }
  .multiselect--active >>> .multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected.multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected:after{
    content: none !important;
  }
.multiselect{
  min-height: 44px;
}
  .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-radius: 3px;
    height: 44px;
    padding: 9px 40px 11px 11px;
    /* border: 1px solid #4D4D4D !important; */
    border: 1px solid #4D4D4D !important;
    /* border: 1px solid #CCCCCC !important; */
  }
  .multiselect-single-dropdown
  >>> .multiselect__select{
    padding-top: 11px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
    padding-top:8px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled {
        background: #ededed;
        pointer-events: none;
        opacity: 0.4;
        /* border: 1px solid #4D4D4D; */

  }
  .multiselect-single-dropdown
  >>> .multiselect__select:before{
    /* border: 1px solid #000000;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg); */
    /* border: 1px solid #0b3c61; */
    /* border-width: 0 1px 1px 0; */
    /* display: inline-block; */
    /* padding: 5px; */
    /* top: 0px;
    content: "";
    border-width: 7px 7px 0;
    padding: 0px !important; */
    position: relative;
    right: 0;
    /* top: 65%; */
    color: #4D4D4D;
    margin-top: 4px;
    border-color:  #4D4D4D transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0;
    content: "";
    transform: rotate(0) !important;
    /* -webkit-transform: rotate(45deg); */
    /* border: 1px solid #0b3c61;
    border-width: 0 2px 2px 0;
    display: inline-block; */
    padding: 0px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__option:hover{
    background: #FFFFFF !important;
  }
  .multiselect--active
  >>> .multiselect__select{
    padding-bottom: 6px !important;
    padding-top: 4px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper .multiselect__option--highlight.multiselect__option--selected{
    /* background: #e6e6e6 !important; */
    /* font-weight: 600 !important; */
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected{
    background: #FFFFFF !important;
    border: 1px solid #0A99FF;

  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected span{
    /* font-weight: 600 !important; */
  }
  .multiselect-single-dropdown
    >>> .multiselect__option--selected:before {
    content: none;
  }
  .multiselect--active
  >>> .multiselect__tags::after{
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 11px;
    right: -13px;
    border: 0.5px solid #CCCCCC !important;
    opacity:0.5;
    width: 95%;

  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    overflow: visible;
    padding-left:0px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__placeholder {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #999999;
    overflow: visible;
    /* padding:7px 0px 7px 12px; */
  }
  .multiselect-single-dropdown >>> .multiselect__input::placeholder{
     color: #4D4D4D !important;
     padding-left:4px !important
  }
   /* .multiselect-single-dropdown input::placeholder{
    color: red;
   } */
.multiselect--active
  >>>  .multiselect__single,
  .multiselect--active
  >>> .multiselect__placeholder{
    padding: 4px 40px 4px 12px;
  }
 .multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown >>> .multiselect__input{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    padding-top: 1px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content{
    margin-top: 5px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 16px;
    padding-top:11px;
    padding-bottom: 10px;
    padding-right: 0px;
  }
  @media screen and (max-width: 1025px) {
    .multiselect--active
  >>> .multiselect__tags::before{
    left: 10px;
    width:94%
  }
}
.multiselect-single-dropdown.multiselect--active
>>> .multiselect__content-wrapper{
    /* border: 1px solid black; */
    border:1px solid #CCCCCC;
    border-top: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-top: 0px;
    max-height: 229px !important;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    /* border-radius:3px !important; */
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    -webkit-box-shadow:none;
     box-shadow: none;
  }
.shadow_box {
  box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.25);
}
.speciality_select >>> .el-input__icon {
  line-height: 30px;
}
.speciality_select {
  display: unset;
}
.speciality_select >>> .el-input__inner {
  border-radius: 20px;
  height: 32px;
  font-weight: 500;
  color: #00518A;
}
.option_check {
  display: none;
  float: right;
  color: #4c9e45;
  margin-top: 10px;
}
.el-select-dropdown__item.selected > .options {
  color: #0b3c61;
}
.el-select-dropdown__item.selected > .option_check {
  display: block;
}
.speciality_select >>> .el-input__inner:focus {
  border-color: #0b3c61;
}
.speciality_select > .is-focus > .el-input__inner {
  border-color: #0b3c61;
}
.tools_radio >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #00518A;
  background: #FFFFFF;
}
.tools_radio >>> .el-radio__input + .el-radio__label {
  display: none;
}
.tools_radio >>> .is-disabled {
  opacity:0.4
}
.tools_radio >>> .el-radio__inner {
 border: 2px solid #4d4d4d;
  width: 18px;
  height: 18px;
}
.tools_radio >>> .el-radio__inner:after {
  width: 10px;
  height: 10px;
  background-color: #00518A;
}

.option_check {
  display: none;
  float: right;
  color: #4c9e45;
  margin-top: 10px;
}

.disclaim-font {
  color: #000000;
  font-size: 10px;
  font-family: Arial, Helvetica, sans-serif;
}
.custom_class {
  margin-right: 0px;
  margin-left: 0px;
  box-shadow: 1px -6px 7px -8px;
}
.mr-lt-20 {
  margin-left: 20px;
}
.mr-lt-86 {
  margin-left: 86px;
}
.csfcn_error {
  color: red;
}
.mr-tp-7 {
  margin-top: 7px;
}
.mr-tp-266 {
  margin-top: 266px;
}
.custom-search {
  border-radius: 20px !important;
}
.content-body {
  /* margin-top: 20px; */
  /* margin-left: 5px; */
  padding-top:24px;

}
.mr-bt-20 {
  margin-bottom: 20px;
}
.mr-tp-20 {
  margin-top: 20px;
}
.search_label {
  margin-top: 0px;
}
.sub_heading {
  font-size: 18px;
  color: #0b3c61;
}
.tools-text,
.page-heading,
.search_label,
.text_body {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
}
/* .tools-text {
  cursor: pointer;
} */
.tools-text > i {
  margin-right: 6px;
}
.page-heading {
  font-weight: 300;
  font-size: 24px;
  color: #0b3c61;
  margin-bottom: 16px;
}
.text_body {
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  color: #3E3E3E;
  /* font-size: 16px; */
  /* margin-top: 20px; */
}
.text-alignment {
  text-align: center;
}
.text_align_right {
  text-align: right;
}
.search_button {
  float: right;
  padding: 6px 33px;
}
.result_title {
  font-size: 24px;
  line-height: 28px;
  color: #0b3c61;
}
.result {
  font-size: 24px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.7);
}
.min_height_150 {
  min-height: 150px;
}
.box_shadow {
  box-shadow: 0px 5px 5px rgba(0, 11, 5, 1);
  border: none;
}
.or {
  /* text-align: center; */
  color: #333333;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  padding-bottom: 3px;
  padding-top: 2px;
}
</style>
